import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import "./COSalidasPage.css";
import './SharedLoading.css';
import API_BASE_URL from "../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const VuelosPage = () => {
  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : null;
  const estacionUsuario = decoded?.estacion?.trim().toUpperCase();

  const [vuelos, setVuelos] = useState([]);
  const [pasajeros, setPasajeros] = useState([]);
  const [selectedVuelo, setSelectedVuelo] = useState(null);
  const [pasajeroSeleccionado, setPasajeroSeleccionado] = useState(null);
  const [modalAsignarVisible, setModalAsignarVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [busquedaSiglas, setBusquedaSiglas] = useState("");
  const [busquedaVuelo, setBusquedaVuelo] = useState("");
  const [loadingPage, setLoadingPage] = useState(true);
  const [mostradorAsignado, setMostradorAsignado] = useState("");
  const [modalMostradorVisible, setModalMostradorVisible] = useState(false);
  const [colaboradorSeleccionado, setColaboradorSeleccionado] = useState(null);


const fechaHoy = moment().format("dddd, D [de] MMMM [de] YYYY"); // Ejemplo: "miércoles, 26 de junio de 2025"


  

  useEffect(() => {
    if (token) {
      obtenerVuelosDelDia();
    }
  }, [token]);

  const obtenerVuelosDelDia = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}api/vuelos/hoy`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const vuelosDelDia = res.data.filter(
        (v) => v.tipoServicio === "SALIDAS"
      );
      setVuelos(vuelosDelDia);
    } catch (error) {
      console.error("❌ Error al obtener vuelos:", error);
      toast.error("Error al obtener vuelos del día");
    } finally {
      setLoadingPage(false);
    }
  };

  const obtenerColaboradores = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}api/bitacora/en-turno-detalles`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Primero filtramos por estación
    const colaboradoresFiltrados = res.data.filter(
      (colab) => colab.estacion?.trim().toUpperCase() === estacionUsuario
    );

    

    // Luego eliminamos duplicados por noColaborador
    const colaboradoresUnicos = colaboradoresFiltrados.filter(
      (colab, index, self) =>
        index === self.findIndex((c) => c.noColaborador === colab.noColaborador)
    );

    setColaboradores(colaboradoresUnicos);
  } catch (error) {
    console.error("❌ Error al obtener colaboradores:", error);
    toast.error("Error al cargar colaboradores disponibles");
  }
};




  const abrirModal = async (vuelo) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}api/vuelos/pasajeros/${vuelo.flight_number}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setPasajeros(res.data);
      setSelectedVuelo(vuelo);
      setModalVisible(true);
    } catch (error) {
      console.error("❌ Error al obtener pasajeros:", error);
      toast.error("Error al cargar pasajeros del vuelo");
    }
  };

  const asignarServicio = async (colab, mostrador) => {
  try {
    const payload = {
      nombrePax: `${pasajeroSeleccionado.nombre} ${pasajeroSeleccionado.apellido}`,
      aerolinea: "AM", // puedes cambiarlo si es dinámico
      noVuelo: selectedVuelo.flight_number,
      noAsiento: pasajeroSeleccionado.tipo_pasajero,
      origenVuelo: selectedVuelo.latest_departure_airport,
      destinoVuelo: selectedVuelo.latest_arrival_airport,
      fechaInput: moment().format("YYYY-MM-DD"),
      horaInicio: moment().format("YYYY-MM-DD HH:mm:ss"),
      estacion: estacionUsuario,
      usuarioInicio: 999,
      noColaborador: colab.noColaborador,
      statusServicio: "ASIGNADO",
      tipoVuelo: selectedVuelo.tipoServicio,
      pnr: pasajeroSeleccionado.pnr,
      int_nac: selectedVuelo.tipoVuelo,
      salida_time: moment(selectedVuelo.published_departure_time).format("YYYY-MM-DD HH:mm:ss"),
      tipoSilla: pasajeroSeleccionado.tipo_silla,
      conexion: pasajeroSeleccionado.conexion,
      noMostrador: mostrador,
    };

    const res = await axios.post(`${API_BASE_URL}api/servicios/asignarSalidas`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    toast.success("✅ Servicio asignado exitosamente");

    // Opcional: cerrar modales y limpiar
    setModalAsignarVisible(false);
    setModalVisible(false);
    setPasajeroSeleccionado(null);
    setSelectedVuelo(null);
    setPasajeros([]);

  } catch (error) {
    console.error("❌ Error al asignar servicio:", error);
    toast.error("Error al asignar el servicio");
  }
};


  const cerrarModal = () => {
    setModalVisible(false);
    setPasajeros([]);
    setSelectedVuelo(null);
  };
  const colaboradoresFiltradosPorBusqueda = colaboradores.filter((colab) =>
  colab.siglas?.toUpperCase().includes(busquedaSiglas)
);

const vuelosOrdenados = [...vuelos].sort((a, b) => {
  const horaA = moment.utc(a.published_departure_time).tz("America/Mexico_City");
  const horaB = moment.utc(b.published_departure_time).tz("America/Mexico_City");
  return horaA - horaB;
});


const vuelosFiltrados = vuelosOrdenados.filter((vuelo) =>
  vuelo.flight_number.toUpperCase().includes(busquedaVuelo)
);



  if (loadingPage) {
    return (
      <div className="container mt-4">
        <div className="page-loading-overlay">
          <div className="page-loading-spinner" />
          <p className="page-loading-text">Cargando vuelos de salidas...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <ToastContainer />
      <h2 className="mb-1 titulo-llegadas">🛬 Vuelos de Salidas del Día</h2>
      <p className="fecha-llegadas mb-3">{fechaHoy}</p>

      <div className="mb-3">
  <input
    type="text"
    className="form-control"
    placeholder="Buscar por número de vuelo"
    value={busquedaVuelo}
    onChange={(e) => setBusquedaVuelo(e.target.value.toUpperCase())}
  />
</div>

     <div className="tabla-salidas-wrapper">
  <div className="titulo-tabla-salidas">SALIDAS</div>
  <table className="tabla-arribos">

  <thead>
  <tr>
    <th>No.</th>
    <th>Hora de llegada</th>
    <th>Destino</th>
    <th>Vuelo</th>
    <th>Sala</th> {/* 👈 nueva columna */}
    <th>Cant. Servicios</th>
    <th>Tipo Vuelo</th>
    <th>Estatus</th>
  </tr>
</thead>


  <tbody>
  {vuelosFiltrados.map((vuelo, idx) => (
    <tr key={vuelo.id} onClick={() => abrirModal(vuelo)} className="fila-arribo">
      <td>{idx + 1}</td>
      <td>{moment(vuelo.published_departure_time).add(1, 'hour').format("HH:mm")}</td>
      <td>{vuelo.latest_arrival_airport}</td>
      <td>AM {vuelo.flight_number}</td>
      <td>{vuelo.sala || 'Sin Servicios'}</td> {/* 👈 nueva celda */}
      <td>{vuelo.totalPasajeros}</td>
      <td>{vuelo.tipoVuelo}</td>
      <td className={vuelo.status === 1 ? 'estatus-completado' : 'estatus-pendiente'}>
        {vuelo.status === 1 ? (
          <>
            <i className="fas fa-check-circle icono-status"></i> Completado
          </>
        ) : (
          <>
            <i className="fas fa-clock icono-status"></i> Pendiente
          </>
        )}
      </td>
    </tr>
  ))}
</tbody>


  </table>
</div>


      {modalVisible && (
        <div className="custom-modal-overlay" onClick={cerrarModal}>
          <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
            <div className="custom-modal-header">
               <span className="title">
                ✈️ <strong>Salida:</strong> {selectedVuelo?.latest_departure_airport} &nbsp;
                <i className="fa fa-arrow-right"></i> &nbsp;
                <strong>Llegada:</strong> {selectedVuelo?.latest_arrival_airport} &nbsp;
                <i className="fa fa-plane"></i> &nbsp;
                <strong>Vuelo:</strong> AM {selectedVuelo?.flight_number} &nbsp;
                <i className="fa fa-clock"></i> <strong>ETA:</strong> {moment(selectedVuelo?.published_arrival_time).add(1,'hour').format('HH:mm')}
              </span>
              <button className="close-button" onClick={cerrarModal}>✕</button>
            </div>

            <div className="custom-modal-body">
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
  <button
    className="btn-agregar"
    onClick={async () => {
      // Simula un "pasajero manual"
      setPasajeroSeleccionado({
        nombre: "",
        apellido: "",
        tipo_silla: "WCHR", // o el default que gustes
        tipo_pasajero: "",
        pnr: "", // puedes generar algo temporal
        conexion: ""
      });

      await obtenerColaboradores(); // ya definida
      setModalAsignarVisible(true); // abre selección de operador
    }}
  >
    Agregar ＋
  </button>
</div>

              <table className="table">
                <thead>
  <tr>
    <th>#</th>
    <th>Nombre</th>
    <th>Apellido</th>
    <th>Tipo silla</th>
    <th>Asiento</th>
    <th>Abordo</th>
    <th>Sala</th>
    <th>PNR</th>
    <th>Acciones</th> 
  </tr>
</thead>

                <tbody>
  {pasajeros.map((p, index) => (
    <tr key={index}>
      <td>{index + 1}</td>
      <td>{p.nombre}</td>
      <td>{p.apellido}</td>
      <td>{p.tipo_silla}</td>
      <td>{p.tipo_pasajero}</td>
      <td>{p.abordo ? "Sí" : "No"}</td>
      <td>{p.sala}</td>
      <td>{p.pnr}</td>
      <td>
  {p.asignado === 1 ? (
    <span className="badge bg-success">Asignado</span>
  ) : (
    <button
      className="btn-asignar"
      onClick={async () => {
        setPasajeroSeleccionado(p);
        await obtenerColaboradores();
        setModalAsignarVisible(true);
      }}
    >
      Asignar
    </button>
  )}
</td>

    </tr>
  ))}
</tbody>

              </table>
            </div>
          </div>
          {modalAsignarVisible && (
  <div className="custom-modal-overlay" onClick={() => setModalAsignarVisible(false)}>
    <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
      <div className="custom-modal-header">
        <span className="title">
          Seleccionar colaborador para: <strong>{pasajeroSeleccionado?.nombre} {pasajeroSeleccionado?.apellido}</strong>
        </span>
        <button className="close-button" onClick={() => setModalAsignarVisible(false)}>✕</button>
      </div>
      <div className="custom-modal-body">
        {/* Aquí insertaremos luego el listado de colaboradores */}
        <input
  type="text"
  placeholder="Buscar por siglas..."
  className="form-control mb-3"
  value={busquedaSiglas}
  onChange={(e) => setBusquedaSiglas(e.target.value.toUpperCase())}
/>

<table className="table">
  <thead>
    <tr>
      <th>#</th>
      <th>Nombre</th>
      <th>Siglas</th>
      <th>Estación</th>
      <th>No. Fila</th>
      <th>Acción</th>
    </tr>
  </thead>
  <tbody>
    
    {colaboradoresFiltradosPorBusqueda.map((colab, idx) => (

      <tr key={colab.noColaborador}>
        <td>{idx + 1}</td>
        <td>{colab.nombreCompleto}</td>
        <td>{colab.siglas}</td>
        <td>{colab.estacion}</td>
        <td>{colab.noFila}</td>
        <td>
          <button
  className="btn-asignar"
  onClick={() => {
    setColaboradorSeleccionado(colab);
    setModalMostradorVisible(true);
  }}
>
  Seleccionar
</button>


        </td>
      </tr>
    ))}
  </tbody>
</table>
      </div>
    </div>
  </div>
)}

{modalMostradorVisible && (
  <div className="custom-modal-overlay" onClick={() => setModalMostradorVisible(false)}>
    <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
      <div className="custom-modal-header">
        <span className="title">Indica a qué mostrador debe ir el colaborador</span>
        <button className="close-button" onClick={() => setModalMostradorVisible(false)}>✕</button>
      </div>
      <div className="custom-modal-body">
        <input
          type="text"
          placeholder="Ejemplo: M1, MOSTRADOR B, PUERTA 3..."
          className="form-control mb-3"
          value={mostradorAsignado}
          onChange={(e) => setMostradorAsignado(e.target.value)}
        />
        <div className="text-end">
          <button
            className="btn btn-success"
            onClick={async () => {
              if (!mostradorAsignado.trim()) {
                toast.warn("Por favor, indica el mostrador");
                return;
              }

              setModalMostradorVisible(false);
              await asignarServicio(colaboradorSeleccionado, mostradorAsignado);
              setMostradorAsignado("");
              setColaboradorSeleccionado(null);
            }}
          >
            Confirmar y Asignar
          </button>
        </div>
      </div>
    </div>
  </div>
)}


        </div>

        
      )}
    </div>
  );
};

export default VuelosPage;